import { createContext, useContext, useMemo } from 'react';

import { referredByVet } from '@farmersdog/lead-browser-storage';
import type { VetCustomPlanType } from '@farmersdog/lead-browser-storage';

import { useReferredByVetUrlParam } from '../useReferredByVetUrlParam';

import type { ReactNode } from 'react';

const VetCustomPlanContext = createContext<VetCustomPlanType>(undefined);

interface VetCustomPlanContextProviderProps {
  children: ReactNode;
}

export function VetCustomPlanContextProvider({
  children,
}: VetCustomPlanContextProviderProps) {
  const vetCustomPlanFromParams = useReferredByVetUrlParam();

  if (vetCustomPlanFromParams) {
    referredByVet.set(JSON.stringify(vetCustomPlanFromParams));
  }

  const vetSessionData = referredByVet.get();
  const vetCustomPlan = useMemo(
    () =>
      vetSessionData ? referredByVet.getParsed(vetSessionData) : undefined,
    [vetSessionData]
  );

  return (
    <VetCustomPlanContext.Provider value={vetCustomPlan}>
      {children}
    </VetCustomPlanContext.Provider>
  );
}

export function useVetCustomPlanContext(): VetCustomPlanType {
  const vetCustomPlan = useContext(VetCustomPlanContext);

  if (vetCustomPlan === null) {
    throw new Error(
      'VetCustomPlanProvider must be used within a VetCustomPlanContextProvider'
    );
  } else {
    return vetCustomPlan;
  }
}
